import React from 'react';
import { BrowserRouter as Router, Routes, Route, Link, Navigate } from 'react-router-dom';
import { ThemeProvider, createTheme } from '@mui/material/styles';
import { CssBaseline, AppBar, Toolbar, Typography, Button, Container } from '@mui/material';
import Home from './pages/Home';
import InsuranceFlow from './pages/InsuranceFlow';
import ComparisonPage from './pages/ComparisonPage';
import InsuranceResults from './pages/InsuranceResults';
import SavingsCalculator from './pages/SavingsCalculator';
import KYCFlow from './pages/KYCFlow';
import Login from './pages/Login';
import Wallet from './pages/Wallet';
import AddPolicy from './pages/AddPolicy';
import PolicyDetails from './pages/PolicyDetails';
import CoverageLimits from './pages/CoverageLimits';
import Cards from './pages/Cards';
import CardViewer from './pages/CardViewer';
import FamilyMembers from './pages/FamilyMembers';
import Documents from './pages/Documents';
import Claims from './pages/Claims';
import SubmitClaim from './pages/SubmitClaim';
import ClaimDetails from './pages/ClaimDetails';
import ClaimHistory from './pages/ClaimHistory';
import Renewals from './pages/renewals/Renewals';
import RenewalDetails from './pages/renewals/RenewalDetails';
import AutoRenewalSettings from './pages/renewals/AutoRenewalSettings';
import RenewalCalendar from './pages/renewals/RenewalCalendar';
import MultiPolicyComparison from './pages/renewals/MultiPolicyComparison';
import RecommendationHistory from './pages/renewals/RecommendationHistory';
import ProtectedRoute from './components/ProtectedRoute';
import OfflineBanner from './components/OfflineBanner';
import PWAInstallPrompt from './components/PWAInstallPrompt';

const theme = createTheme({
  palette: {
    mode: 'light',
    primary: {
      main: '#1976d2',
    },
    secondary: {
      main: '#dc004e',
    },
  },
});

function App() {
  const handleLogout = () => {
    localStorage.removeItem('auth_token');
    localStorage.removeItem('user');
    window.location.href = '/login';
  };

  const isLoggedIn = !!localStorage.getItem('auth_token');

  return (
    <ThemeProvider theme={theme}>
      <CssBaseline />
      <Router>
        <AppBar position="static">
          <Toolbar>
            <Typography variant="h6" sx={{ flexGrow: 1 }}>
              <Link to="/" style={{ color: 'white', textDecoration: 'none' }}>
                Tutamen
              </Link>
            </Typography>
            {isLoggedIn ? (
              <>
                <Button color="inherit" component={Link} to="/">
                  Home
                </Button>
                <Button color="inherit" component={Link} to="/wallet">
                  Wallet
                </Button>
                <Button color="inherit" component={Link} to="/claims">
                  Claims
                </Button>
                <Button color="inherit" component={Link} to="/renewals">
                  Renewals
                </Button>
                <Button color="inherit" component={Link} to="/kyc">
                  KYC
                </Button>
                <Button color="inherit" onClick={handleLogout}>
                  Logout
                </Button>
              </>
            ) : (
              <Button color="inherit" component={Link} to="/login">
                Login
              </Button>
            )}
          </Toolbar>
        </AppBar>
        <OfflineBanner />

        <Routes>
          <Route path="/" element={<Home />} />
          <Route path="/login" element={<Login />} />
          <Route path="/kyc" element={
            <ProtectedRoute>
              <KYCFlow />
            </ProtectedRoute>
          } />

          <Route path="/insurance/:category" element={<InsuranceFlow />} />
          <Route path="/insurance-results" element={<InsuranceResults />} />
          <Route path="/checkout" element={<div>Checkout Coming Soon</div>} />
          <Route path="/product/:productId" element={<div>Product Details Coming Soon</div>} />
          <Route path="/compare" element={<ComparisonPage />} />
          <Route path="/ai-advisor" element={<div>AI Advisor Coming Soon</div>} />
          <Route path="/browse" element={<div>Browse Products Coming Soon</div>} />
          <Route path="/calculator" element={<SavingsCalculator />} />
          <Route path="/wallet" element={<ProtectedRoute><Wallet /></ProtectedRoute>} />
          <Route path="/wallet/add" element={<ProtectedRoute><AddPolicy /></ProtectedRoute>} />
          <Route path="/wallet/policy/:id" element={<ProtectedRoute><PolicyDetails /></ProtectedRoute>} />
          <Route path="/wallet/limits" element={<ProtectedRoute><CoverageLimits /></ProtectedRoute>} />
          <Route path="/cards" element={<ProtectedRoute><Cards /></ProtectedRoute>} />
          <Route path="/cards/:id" element={<ProtectedRoute><CardViewer /></ProtectedRoute>} />
          <Route path="/family" element={<ProtectedRoute><FamilyMembers /></ProtectedRoute>} />
          <Route path="/documents" element={<ProtectedRoute><Documents /></ProtectedRoute>} />
          <Route path="/claims" element={<ProtectedRoute><Claims /></ProtectedRoute>} />
          <Route path="/claims/submit" element={<ProtectedRoute><SubmitClaim /></ProtectedRoute>} />
          <Route path="/claims/policy/:id" element={<ProtectedRoute><ClaimHistory /></ProtectedRoute>} />
          <Route path="/claims/:id" element={<ProtectedRoute><ClaimDetails /></ProtectedRoute>} />
          <Route path="/renewals" element={<ProtectedRoute><Renewals /></ProtectedRoute>} />
          <Route path="/renewals/calendar" element={<ProtectedRoute><RenewalCalendar /></ProtectedRoute>} />
          <Route path="/renewals/compare" element={<ProtectedRoute><MultiPolicyComparison /></ProtectedRoute>} />
          <Route path="/renewals/:id" element={<ProtectedRoute><RenewalDetails /></ProtectedRoute>} />
          <Route path="/renewals/:id/settings" element={<ProtectedRoute><AutoRenewalSettings /></ProtectedRoute>} />
          <Route path="/renewals/:id/history" element={<ProtectedRoute><RecommendationHistory /></ProtectedRoute>} />
        </Routes>
      </Router>
      <PWAInstallPrompt />
    </ThemeProvider>
  );
}

export default App;
